<template>
  <div class="global-container">
    <h1><span>Paramètres / </span>Entreprise</h1>
    <div class="bento-container">

      <div class="bento-item">
        <h3>Groupe</h3>
        <GroupParametersForm/>
      </div>

      <div class="bento-item" v-if="isBusinessModule" >
        <h3>Identité de l'entreprise</h3>
        <BusinessGroupIdentityForm/>
      </div>

      <div class="bento-item" v-if="isBusinessModule" >
        <h3>Package Essentiel</h3>
        <BusinessGroupParametersForm/>
      </div>

      <div class="bento-item">
        <h3>Modules</h3>
        <OptionList/>
      </div>

    </div>
  </div>
</template>

<script>
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faChevronUp, faChevronDown } from "@fortawesome/free-solid-svg-icons";
    library.add(faChevronUp);
    library.add(faChevronDown);
    import BusinessGroupParametersForm from "@/components/forms/BusinessGroupParametersForm.vue";
    import BusinessGroupIdentityForm from "@/components/forms/BusinessGroupIdentityForm.vue";
    import GroupParametersForm from "@/components/forms/GroupParametersForm.vue";
    import OptionList from "@/components/OptionList.vue";

    export default {
        name: 'UserParametersView',
        components: {
          OptionList,
          BusinessGroupParametersForm,
          BusinessGroupIdentityForm,
          GroupParametersForm
        },
        computed: {
          isBusinessModule(){
            return localStorage && localStorage.options && localStorage.options.includes('business');
          },
        }
    }
</script>

<style lang="stylus" scoped>
  @require '~/src/common/style/common.styl';

  h1
    color: THEME_COLOR_PRIMARY
    span
      color: THEME_COLOR_PRIMARY_FADDED

  .bento-item
    height: auto

    @media only screen and (min-width: DESKTOP_SIZE)
      grid-template-columns: repeat(2, 1fr)

  .bento-item.large
    background-color: #ffb3b3

  .bento-item.tall
    background-color: #b3d9ff

  .bento-item.wide
    background-color: #d1ffb3

  @media only screen and (min-width: DESKTOP_SIZE)
    .bento-container
      column-count: 2
</style>
